import React, { Component } from 'react';
import TitleBar from '../../components/title_bar';
import { SetPageBKColor } from '../../globals';
import '../../css/common.css';
import '../../css/new_account.css';

export default class NewAccount extends Component {

  componentDidMount() {
    SetPageBKColor();
  }

  onCreateAcct() {
    alert('Sorry, new account creations are currently available in the DineStein App only.')
  }

  render() {
    return (
       <div id="bk-div">
         <TitleBar showContact={true} showBack={true} />
         <div id="main-form">
           <div id="main-form-inner">
             <div id="create-acct">
               <span className="data-lbl">Create your myDinestein Account</span>
             </div>
             <hr />
             <div>&nbsp;</div>
             <div>
               <table id="form-tbl" align="center" border="0" cellpadding="0" cellspacing="0">
                 <tr>
                   <td className="data-lbl align-left">Email*</td>
                 </tr>
                 <tr>
                   <td className="highlight-font data-txt">
                     <input id="txtEmailAddy" ref="txtEmailAddy" placeholder="Email Address" className="highlight-font data-txt" />
                   </td>
                 </tr>
                 <div>&nbsp;</div>
                 <tr>
                   <td className="data-lbl align-left">Account Id*</td>
                 </tr>
                 <tr>
                   <td className="highlight-font data-txt">
                     <input id="txtAccountId" ref="txtAccountId" placeholder="Account Id" className="highlight-font data-txt" />
                   </td>
                 </tr>
                 <div>&nbsp;</div>
                 <tr>
                   <td className="data-lbl align-left">Password*</td>
                 </tr>
                 <tr>
                   <td className="highlight-font data-txt">
                     <input id="txtCreatePassword" type="password" ref="txtCreatePassword" placeholder="Password" className="highlight-font data-txt" />
                   </td>
                 </tr>
                 <div>&nbsp;</div>
                 <tr>
                   <td className="data-lbl align-left">Nickname (within family)</td>
                 </tr>
                 <tr>
                   <td className="highlight-font data-txt">
                     <input id="txtNickname" ref="txtNickname" placeholder="Nickname" className="highlight-font data-txt" />
                   </td>
                 </tr>
                 <div>&nbsp;</div>
                 <tr>
                   <td className="data-lbl align-left">Postal Code (to find local stores)</td>
                 </tr>
                 <tr>
                   <td className="highlight-font data-txt">
                     <input id="txtZipCode" ref="txtZipCode" placeholder="Postal Code" className="highlight-font data-txt" />
                   </td>
                 </tr>
              </table>
              <div>&nbsp;</div>
              <div onClick={ ()=>{ this.onCreateAcct() }} id="create-btn" className="btn-bk">Create Account</div>

{/*
             <div id="fname-grp">
               <div className="data-lbl ">First Name</div>
               <div>
                 <input id="txtFirstName" ref="txtFirstName" placeholder="First Name" className="highlight-font data-txt" />
               </div>
             </div>

             <div id="lname-grp">
               <div className="data-lbl ">Last Name</div>
               <div>
                 <input id="txtLastName" ref="txtLastName" placeholder="Last Name" className="highlight-font data-txt" />
               </div>
             </div>

             <div id="addr1-grp">
               <div className="data-lbl ">Address Line 1</div>
               <div>
                 <input id="txtAddress1" ref="txtAddress1" placeholder="Address 1" className="highlight-font data-txt" />
               </div>
             </div>

             <div id="addr2-grp">
               <div className="data-lbl ">Address Line 2</div>
               <div>
                 <input id="txtAddress2" ref="txtAddress2" placeholder="Address 2" className="highlight-font data-txt" />
               </div>
             </div>
</div>
             <div id="appt-grp">
               <div className="data-lbl ">Apartment/Unit</div>
               <div>
                 <input id="txtApt" ref="txtApt" placeholder="Apartment" className="highlight-font data-txt" />
               </div>
             </div>

             <div id="city-grp">
               <div className="data-lbl ">City</div>
               <div>
                 <input id="txtCity" ref="txtCity" placeholder="City" className="highlight-font data-txt" />
               </div>
             </div>

             <div id="state-grp">
               <div className="data-lbl ">State</div>
               <div>
                 <input id="txtState" ref="txtState" placeholder="State" className="highlight-font data-txt" />
               </div>
             </div>

             <div id="email-grp">
               <div className="data-lbl ">Email</div>
               <div>
                 <input id="txtEmailAddy1" ref="txtEmailAddy" placeholder="Email Address" className="highlight-font data-txt" />
               </div>
*/}
             </div>
           </div>
         </div>
       </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/new_account/new_account.js